import { useSelector } from 'react-redux'

import { actionTypes } from 'actions/actionTypes'
import { createGetErrorForActionType } from 'selectors/status'

import { checkoutErrors, defaultCheckoutError } from './checkoutErrors'

type CheckoutError = {
  actionLabel?: string
  errorCode?: string
  errorMessage?: string
  errorTitle?: string
  originalErrorMessage?: string
  retryFunc?: () => void
}

export const useCheckoutError = (): CheckoutError => {
  const orderSaveError = useSelector(createGetErrorForActionType(actionTypes.ORDER_SAVE))
  const hasOrderSaveError = Boolean(orderSaveError)

  if (!hasOrderSaveError) {
    return {
      errorCode: undefined,
    }
  }

  const originalErrorMessage =
    typeof orderSaveError === 'string' ? orderSaveError : orderSaveError.message ?? ''

  const checkoutError = checkoutErrors.find((e) => e.match(originalErrorMessage))

  if (checkoutError) {
    return { ...checkoutError, originalErrorMessage }
  }

  return { ...defaultCheckoutError, originalErrorMessage }
}
